export const postalCode = (value: any) => {
  const reg = /^\d{3}-\d{4}$/;
  return reg.test(value);
};

export const fullWidth = (value: any) => {
  const reg = /^[^ -~｡-ﾟ]*$/;
  return reg.test(value);
};

export const halfWidth = (value: any) => {
  const reg = /[^\uff60-\uff9f-A-Za-z0-9_., +]/;
  return !reg.test(value);
};

export const onlyJAorEN = (value: string) => {
  if (value === '' || value === undefined) {
    return true;
  }
  const reg = /^[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf-A-Za-z0-9_., +]*$/;
  return reg.test(value);
};

export const onlyASCII = (value: string, extended: boolean = false) => {
  if (value === '' || value === undefined) {
    return true;
  }
  // eslint-disable-next-line no-control-regex
  const reg = extended ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/;
  return reg.test(value);
};

export const validPhone = (value: string) => {
  if (value === '' || value === undefined) {
    return true;
  }
  // eslint-disable-next-line no-useless-escape
  const reg = /^[+]*[0-9]{0,1}\s?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4}$/im;
  return reg.test(value);
};

export const iOSSafary = () => {
  // eslint-disable-next-line no-useless-escape
  return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
};

export const strongPassword = (value: string) => {
  if (value === '' || value === undefined) {
    return true;
  }
  const reg = /^(?=.{12,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/])/;
  return reg.test(value);
};
